import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, Box, Button, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import H6 from '../../common/typographys/H6';
import SelectOutlined from '../../common/forms/SelectOutlined';
import InputField from '../../common/forms/InputField';

const useStyles = makeStyles(() => ({
  content: {
    padding: '36px 48px!important',
    minWidth: '420px',
  },
  field: {
    marginBottom: '4px',
  },
  boxButtons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
    gap: '8px'
  },
}));

// O menu do react-select é renderizado num portal em document.body, que fica atrás do
// backdrop do Dialog (MUI) sem este override.
const typeSelectStyles = {
  menuPortal: base => ({
    ...base,
    zIndex: '9999!important',
  }),
};

const DialogBeforeDayOrderItem = ({ open, item, onClose, onSave }) => {
  const classes = useStyles();
  const types = useSelector(state => state.beforeDayOrder?.types || []);
  const [typeId, setTypeId] = useState(null);
  const [title, setTitle] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (open) {
      setTypeId(item ? item.type_id : null);
      setTitle(item ? item.title || '' : '');
      setIdentifier(item ? item.identifier || '' : '');
      setDescription(item ? item.description || '' : '');
    }
  }, [open, item]);

  const typeOptions = types.map(type => ({ value: type.id, label: type.name }));

  const canSave = Boolean(typeId) && description.trim().length > 0;

  const handleSave = () => {
    if (!canSave) return;

    const selectedType = types.find(type => type.id === typeId) || {};

    onSave({
      type_id: typeId,
      type_name: selectedType.name,
      title,
      identifier,
      description,
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent className={classes.content}>
        <H6>{item ? 'Editar' : 'Adicionar'} voto</H6>
        <Box height="20px" />
        <Box className={classes.field}>
          <SelectOutlined
            label="Tipo"
            name="before-day-order-type"
            options={typeOptions}
            otherStyles={typeSelectStyles}
            value={typeOptions.find(option => option.value === typeId) || null}
            onChange={option => setTypeId(option ? option.value : null)}
          />
          <Box height="20px" />
        </Box>
        <InputField label="Título" value={title} onChange={e => setTitle(e.target.value)} />
        <InputField
          label="Identificação"
          value={identifier}
          onChange={e => setIdentifier(e.target.value)}
          placeholder="Ex: Moção de Pesar n.º 3/2026"
        />
        <InputField
          label="Descrição"
          value={description}
          onChange={e => setDescription(e.target.value)}
          multiline
          rows={4}
        />
        <Box className={classes.boxButtons}>
          {/* <Button onClick={onClose}>Cancelar</Button> */}
          <Button
            variant="contained"
            color="primary"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            variant="contained"
            disabled={!canSave}
            onClick={handleSave}
          >
            Guardar
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

DialogBeforeDayOrderItem.defaultProps = {
  item: null,
};

DialogBeforeDayOrderItem.propTypes = {
  open: PropTypes.bool.isRequired,
  item: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default React.memo(DialogBeforeDayOrderItem);
